import { Link } from 'react-router-dom';

const TermsOfServicePage = () => {
  return (
    <div data-testid="terms-of-service-page">
      {/* Hero Section */}
      <section className="relative bg-[#0F172A] pt-32 pb-16 noise-overlay">
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-white mb-4">
            Terms of Service
          </h1>
          <p className="text-slate-400">Last updated: March 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 prose prose-slate max-w-none">
          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">1. Agreement to Terms</h2>
          <p className="text-slate-600 mb-4">
            By accessing or using Supply Hub's website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">2. Services</h2>
          <p className="text-slate-600 mb-4">
            Supply Hub provides international procurement and sourcing services, including but not limited to:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-4">
            <li>Procurement outsourcing</li>
            <li>International sourcing</li>
            <li>Supplier identification and negotiation</li>
            <li>Order management</li>
            <li>Logistics coordination</li>
            <li>Industrial and agro-industrial supply</li>
          </ul>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">3. Quote Requests</h2>
          <p className="text-slate-600 mb-4">
            Quote requests submitted through our website are non-binding inquiries. A formal agreement will only be established upon mutual written consent between Supply Hub and the client.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">4. Intellectual Property</h2>
          <p className="text-slate-600 mb-4">
            All content on this website, including text, graphics, logos, and images, is the property of Supply Hub and is protected by intellectual property laws.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">5. Limitation of Liability</h2>
          <p className="text-slate-600 mb-4">
            Supply Hub shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services or website.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">6. Governing Law</h2>
          <p className="text-slate-600 mb-4">
            These Terms of Service are governed by the laws of Belgium. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Brussels, Belgium.
          </p>

          <h2 className="font-['Outfit'] text-2xl font-semibold text-[#0F172A] mt-8 mb-4">7. Contact Information</h2>
          <p className="text-slate-600 mb-4">
            For questions about these Terms of Service, please contact us at:
          </p>
          <p className="text-slate-600 mb-4">
            <strong>Supply Hub</strong><br />
            Silversquare, 523 Avenue Louise<br />
            1050 Bruxelles, Belgique<br />
            Email: <a href="mailto:jemimabolokwa@supply-hub.eu" className="text-[#0EA5E9]">jemimabolokwa@supply-hub.eu</a><br />
            Phone: +32 496 79 64 61
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
